import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { Features } from './components/Features';
import { UseCases } from './components/UseCases';
import { Security } from './components/Security';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-navy-900" data-id="element-0">
      <Navbar data-id="element-1" />
      <Hero data-id="element-2" />
      <HowItWorks data-id="element-3" />
      <Features data-id="element-4" />
      <UseCases data-id="element-5" />
      <Security data-id="element-6" />
      <CTASection data-id="element-7" />
      <Footer data-id="element-8" />
    </div>;
}